import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Email Fill
 */

export default function EmailFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M2 3C1.44772 3 1 3.44772 1 4V4.49991C1.08426 4.49984 1.16967 4.52108 1.24807 4.56588L8 8.42412L14.7519 4.56588C14.8303 4.52108 14.9157 4.49984 15 4.49991V4C15 3.44772 14.5523 3 14 3H2ZM15 5.57588L8.24807 9.43412C8.09435 9.52196 7.90565 9.52196 7.75193 9.43412L1 5.57588V12C1 12.5523 1.44772 13 2 13H14C14.5523 13 15 12.5523 15 12V5.57588Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
